export default {"src":"/uk/_next/static/media/spot-plus-sign.ad4ab30f.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};